<template>
  <Loading v-if="!fullyLoaded" />
  <Form v-else :chemicals="chemicals" :plantUsers="plantUsers" :submit="submit" :cancel="cancel" />
</template>

<script>
import _ from 'lodash';

import CreateView from '@/mixins/createView';
import ResourceService from '@/services/resources/applications_service';
import ChemicalService from '@/services/resources/chemicals_service';
import AppStepService from '@/services/resources/application_steps_service';
import PlantUserService from '@/services/resources/plant_users_service';
import AppPermissionService from '@/services/resources/application_permissions_service';

export default {
  mixins: [CreateView],
  components: {
    Form: () => import('@/components/forms/ApplicationForm.vue'),
  },
  data() {
    return {
      urlFragment: 'applications',
      resourceService: ResourceService,
    };
  },
  asyncComputed: {
    chemicals: {
      get() {
        const options = {
          filter: {
            site: this.siteId,
          },
        };
        return ChemicalService.index(options).then((chemicals) => {
          return chemicals.data;
        });
      },
      default: [],
      shouldUpdate() {
        return this.asyncComputedShouldUpdate();
      },
    },
    plantUsers: {
      get() {
        const options = {
          filter: {
            site: this.siteId,
          },
        };
        return PlantUserService.index(options).then((plantUsers) => {
          return plantUsers.data;
        });
      },
      default: [],
      shouldUpdate() {
        return this.asyncComputedShouldUpdate();
      },
    },
  },
  methods: {
    submit(resource) {
      resource.site = this.siteId;
      const { appSteps, appPermissions, ...appAttributes } = resource;
      return this.resourceService
        .create(appAttributes)
        .then((app) => {
          const stepPromises = appSteps.map((step) => {
            step.app = app.data;
            return AppStepService.create(step);
          });

          if (!_.isEmpty(appPermissions)) {
            const permissionPromises = appPermissions.map((permission) => {
              permission.app = app.data;
              return AppPermissionService.create(permission);
            });

            return Promise.all([...stepPromises, ...permissionPromises]).then(() => {
              const { name } = app.data;
              this.successToast(`Created ${name}`);
              this.$router.push(this.destination);
            });
          } else {
            return Promise.all([...stepPromises]).then(() => {
              const { name } = app.data;
              this.successToast(`Created ${name}`);
              this.$router.push(this.destination);
            });
          }
        })
        .catch(this.failToast);
    },
  },
};
</script>
